module.exports = __webpack_public_path__ + "img/r13.8056b655.png";